import { NuqsAdapter } from "nuqs/adapters/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initRudderstack } from "./utils/rudderstack.ts";
import { initSentry } from "./utils/sentry";

// Initialise Sentry
initSentry();

initRudderstack();

// Create root and render app
const root = createRoot(document.getElementById("root")!);
root.render(
  <StrictMode>
    <NuqsAdapter>
      <App />
    </NuqsAdapter>
  </StrictMode>,
);
